<template>
  <div class="container-fluid p-0">
    <div @click="openModal" class="version-container">
      <span class="version">UNODC Version {{ version }}</span
      ><br />
      <span class="rights">&copy;{{currentYear}}. All Rights Reserved</span>
    </div>

    <div>
      <b-modal v-model="showModal" hide-footer hide-header-close @hide="onHide">
        <template #modal-title>
          <div
            style="display: flex; align-items: center; justify-content: space-between; width: 100%;"
          >
            <div style="color: #00a6e4; display: flex; align-items: center;">
              <span class="ml-2">UNODC Update Version {{ version }}</span>
            </div>
          </div>
        </template>

        <div v-html="htmlContent"></div>
        <div style="text-align: right;">
          <button
            @click="showModal = false"
            style="background-color: #00a6e4; color: white; border: none;  padding: 5px 15px; border-radius: 4px;"
          >
            Close
          </button>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { htmlContent } from '../../utils/config.js';


export default {
  data: () => ({
   active: true,
        basepath: localStorage.getItem("BASE_PATH"),
        showModal: false,
        version: '',
        releaseDate: '',
        htmlContent: htmlContent,
       currentYear: new Date().getFullYear()
  }),
  mounted() {

        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        const appVersion = localStorage.getItem("version")
        axios
            .post(localStorage.getItem("BASE_PATH") + "/get-version")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if(appVersion != response.data.versionNo){
                  this.showModal = true
                }
                localStorage.setItem("version",response.data.versionNo)
                this.version = response.data.versionNo;
                this.releaseDate = response.data.releaseDate;
                // this.htmlContent = response.data.htmlContent;
            });

    },
    created() {

    },

    methods: {
        openModal() {
            this.showModal = true;
        },

    }
};
</script>

<style scoped>


.bg-primary {
  /* height: 50px !important; */
  background: #06a6e0 !important;
}


.version-container {
  cursor: pointer;
  padding: 1px;
  background-color: #f4f4f4;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease, transform 0.3s ease;
  text-align: center;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.version-container:hover {
  background-color: #eaeaea;
  transform: scale(1.05);
}

.version {
  font-weight: bold;
  font-size: 1.2em;
  color: #333;
}

.rights {
  font-size: 0.9em;
  color: #777;
}

@media (max-width: 768px) {

}
</style>
